import React from "react";
import Modal from "../ModalTemplate";
import Button from "../Button";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import "./style.scss";
import prizeBg from "./img/decor.png";
import spider from "./img/spider.svg";

export default NiceModal.create(() => {
  const modal = useModal();

  return (
    <Modal
      isOpen={modal.visible}
      onClose={() => {
        modal.hide();
      }}
      onAfterClose={() => modal.remove()}
      innerClass={`last-object-modal`}
    >
      <div className="content-wrapper">
        <img className="object-svg" src={spider} alt="spider-icon" />
        <p>
          <span>
            5/5 <br />
            Geschafft!
          </span>
        </p>
        <p>Du hast alle 5 Spinne gefangen!</p>

        <div className="reward-box">
          <div className="copy">Du&nbsp;erhältst: </div>
          <div className="value">
            <img className="img" src={prizeBg} alt={data?.payout} />
            <div className="prize">
              <div className="inner">
                +20
                <span className="prize-copy">Punkte</span>
              </div>
            </div>
          </div>
        </div>

        <div className="buttons-wrapper">
          <Button
            btnClass="yellow"
            action={(e) => {
              modal.hide();
            }}
          >
            OK
          </Button>
        </div>
      </div>
    </Modal>
  );
});
